var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 16.625V15.0417C13.4583 14.2018 13.1247 13.3964 12.5308 12.8025C11.9369 12.2086 11.1315 11.875 10.2916 11.875H3.95829C3.11844 11.875 2.31299 12.2086 1.71912 12.8025C1.12526 13.3964 0.791626 14.2018 0.791626 15.0417V16.625",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12504 8.70833C8.87394 8.70833 10.2917 7.29057 10.2917 5.54167C10.2917 3.79277 8.87394 2.375 7.12504 2.375C5.37614 2.375 3.95837 3.79277 3.95837 5.54167C3.95837 7.29057 5.37614 8.70833 7.12504 8.70833Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2084 16.6251V15.0418C18.2078 14.3401 17.9743 13.6586 17.5445 13.104C17.1146 12.5495 16.5127 12.1534 15.8334 11.978",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 2.47803C13.3478 2.65243 13.9515 3.04858 14.3827 3.60402C14.8138 4.15946 15.0478 4.8426 15.0478 5.54574C15.0478 6.24887 14.8138 6.93201 14.3827 7.48745C13.9515 8.04289 13.3478 8.43904 12.6666 8.61344",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9ca3c1069a6161c3969c642b9d515bb0.svg";
export { ForwardRef as ReactComponent };